import { Stack, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const AccessTypeSelector = ({ 
  value, 
  onChange, 
  list, 
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Stack 
      direction="row" 
      spacing={1} 
      sx={{
        mb: 2,
      }}
    >
      <ToggleButtonGroup
        color="primary"
        value={value}
        size="small"
        exclusive
        onChange={(e,v) => v && onChange(v)}
      >
        {
          list.map((filter) => (
            <ToggleButton 
              value={filter.value}
              key={filter.value}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: {
                  xs: '0.75rem',
                  sm: '0.875rem',
                },
                '&.Mui-selected': {
                  color: theme.palette.text.primary,
                  textTransform: 'none',
                  border: '1px solid',
                  borderColor: theme.palette.primary.main,
                  // backgroundColor: theme.palette.primary.main,
                  // color: 'white',
                }

              }}
            >
              { filter.icon }
              {t(filter.translationKey)}
            </ToggleButton>
          ))
        }
      </ToggleButtonGroup>
    </Stack>
  )
}

export default AccessTypeSelector;